/**
 * Utility functions for scroll operations
 * Centralizes scroll reset logic to reduce duplication
 */

/**
 * Scrolls to the top of the page
 * Resets scroll position for window, body, and documentElement
 */
export function scrollToTop(): void {
  window.scrollTo(0, 0);
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

